import { Vector2 } from "../../math";
import { TileTransform } from "./TileTransform";
export var TileCoordinates;
(function (TileCoordinates) {
    function eq(a, b) {
        return Vector2.eq(a, b) && a.level == b.level;
    }
    TileCoordinates.eq = eq;
    function eq2(a, b) {
        return a != null && b != null && (a == b || eq(a, b));
    }
    TileCoordinates.eq2 = eq2;
    function equals(a, b) {
        return a == b || eq2(a, b);
    }
    TileCoordinates.equals = equals;
    function lift(v, level) {
        return { ...v, level: level };
    }
    TileCoordinates.lift = lift;
    function move(pos, off) {
        if (!pos)
            debugger;
        return {
            x: pos.x + off.x,
            y: pos.y + off.y,
            level: pos.level
        };
    }
    TileCoordinates.move = move;
    function toString(coordinate) {
        return `${coordinate.x} | ${coordinate.y} | ${coordinate.level}`;
    }
    TileCoordinates.toString = toString;
    function snap(coordinate, granularity = 1) {
        if (granularity == 0)
            return coordinate;
        return {
            x: Math.round(coordinate.x / granularity) * granularity,
            y: Math.round(coordinate.y / granularity) * granularity,
            level: coordinate.level
        };
    }
    TileCoordinates.snap = snap;
    function distance(a, b) {
        return Vector2.max_axis(Vector2.sub(a, b));
    }
    TileCoordinates.distance = distance;
    function transform(coordinates, trans) {
        let norm = TileTransform.normalize(trans);
        return lift(Vector2.transform_point(coordinates, norm.matrix), coordinates.level + norm.level_offset);
    }
    TileCoordinates.transform = transform;
    function chunk(coords) {
        return { x: Math.floor(coords.x / 64), y: Math.floor(coords.y / 64) };
    }
    TileCoordinates.chunk = chunk;
    function toShortString(coords) {
        return `${coords.x}.${coords.y}.${coords.level}`;
    }
    TileCoordinates.toShortString = toShortString;
})(TileCoordinates || (TileCoordinates = {}));
